import styled from 'styled-components';
import TopAreas from './components/top-areas/TopAreas';
import Landing from './components/landing-section';
import TopCompounds from './components/top-compounds/TopCompounds';
import RecommendedSection from './components/recommended-section/RecommendedSection';
import ServicesContainer from './components/services-cards/ServiceContainer';
import LaunchesBannerContainer from '../entity/launch/components/LaunchesBanner/LaunchesBannerContainer';
import { useSelector } from 'react-redux';
import Pathways from './components/pathways/Pathways';
import WebAppJourney from './components/web-app-journey/WebAppJourney';
import DynamicBanners from './components/dynamic-banners';
import ExpoBanner from './components/expo';

const HomePageContainer = (props: any) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const userLocation = useSelector((state: any) => state.app.userLocation);
  return (
    <HomeContainer>
      <Landing />
      {props?.pathways?.length > 0 && (
        <HomeWrapper className="container-fluid">
          <Pathways pathways={props.pathways} />
        </HomeWrapper>
      )}

      {props.dynamicBanners?.length > 0 && (
        <DynamicBanners banners={props.dynamicBanners} />
      )}

      <div className="launches-home-banner container-fluid">
        <LaunchesBannerContainer launches={props.launches} />
      </div>
      <HomeWrapper className="container-fluid">
        <TopCompounds popularCompounds={props.popularCompounds} />
        {isMobile ? <ServicesContainer /> : <></>}
      </HomeWrapper>
      <HomeWrapper className="container-fluid">
        <TopAreas topAreas={props.topAreas} />
        {!isMobile ? <ServicesContainer /> : <></>}
        <RecommendedSection />
      </HomeWrapper>

      <HomeWrapper className="container-fluid">
        <WebAppJourney />
      </HomeWrapper>
      {userLocation?.countryCode == 'QA' ||
      userLocation?.countryCode == 'SA' ? (
        <ExpoBanner />
      ) : null}
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 64px;
  margin-bottom: 64px;

  > div:nth-child(2) {
    margin-top: 100px;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    gap: 32px;
    margin-bottom: 32px;

    > div:nth-child(2) {
      margin-top: 0px;
    }
  }
`;

const HomeWrapper = styled.div<any>`
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 64px;

  &.banners-container {
    height: auto;
    gap: 16px;
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    > div,
    a {
      min-width: 542px;
      height: 188px;
    }
  }
  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    gap: 32px;

    &.banners-container {
      height: 130px;
      overflow-x: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
      ::-webkit-scrollbar {
        display: none;
      }

      .banners-inner-container {
        height: 100%;
        width: max-content;
        display: flex;
        flex-direction: row;
        gap: 8px;
        ::-webkit-scrollbar {
          display: none;
        }

        > div,
        a {
          min-width: 260px;
          height: 130px;
        }
      }
    }
  }
`;

export default HomePageContainer;
